import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VContainer,[_c(VRow,{attrs:{"dense":""}},[_c(VCol,{attrs:{"cols":"12"}},[_c('DataTableMain',{attrs:{"datatable":_vm.table,"on-success":_vm.successAction,"items-action":_vm.tableAction}})],1)],1),(_vm.get_dialogMain.dialog)?_c('MainFormDialog',{attrs:{"model":_vm.object,"params":_vm.paramsDialog}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }